import {Component, OnInit, OnDestroy} from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";
import {AppConfig} from "../app.config";
import {HttpService} from "../services/http.service";

@Component({
    selector: 'app-contact',
    templateUrl: './contact.component.html'
})
export class ContactComponent implements OnInit, OnDestroy {
    public activeBlock = 'subscribe';
    public sub: any;
    public modelSub = {};
    public modelEmail = {};
    public modelCall = {};


    constructor(
                public http: HttpService,
                private activatedRoute: ActivatedRoute) {
                this.sub = this.activatedRoute.queryParams.subscribe(params => {
                this.activeBlock = params['form'] || 'subscribe';
        });
    }

    ngOnInit() {
    }

    ngOnDestroy() {
        this.sub.unsubscribe();
    }

    sendMessageSub(event) {
        event.preventDefault();

        const formData = new FormData();
        const url = AppConfig.baseUrlApi + 'subscribers/api_subscribe_validation';

        for (const name in this.modelSub) {
            if (!this.modelSub.hasOwnProperty(name)) {
                continue;
            }
            formData.append(name, this.modelSub[name]);
        }

        this.sendRequest(url, formData);

    }

    sendMessageCall(event) {
        event.preventDefault();

        const formData = new FormData();
        const url = AppConfig.baseUrlApi + 'call_me/api_insert_call';

        for (const name in this.modelCall) {
            if (!this.modelCall.hasOwnProperty(name)) {
                continue;
            }
            formData.append(name, this.modelCall[name]);
        }

        this.sendRequest(url, formData);
    }

    sendMessageEmail(event) {
        event.preventDefault();

        const formData = new FormData();
        const url = AppConfig.baseUrlApi + 'contacts/api_insert_contact';

        for (const name in this.modelEmail) {
            if (!this.modelEmail.hasOwnProperty(name)) {
                continue;
            }
            formData.append(name, this.modelEmail[name]);
        }

        this.sendRequest(url, formData);
    }

    sendRequest(url, formData) {
        this.http.post(url, formData).subscribe(response => {
            if (response.message === 'ok') {
                alert('Message was sent');
                this.modelEmail = {};
                this.modelCall = {};
                this.modelSub = {};
            } else {
                alert(response.content);
            }
        }, error => {
            console.log(error);
        });
    }
}



// WEBPACK FOOTER //
// /home3/usalinks/public_html/ally-book-source/src/app/contact/contact.component.ts